import { useRef } from 'react'
import { ALMANAC_CORE_WORKSPACE_ID } from 'utils/constants'
import { useCurrentArticleMeta } from 'hooks/useCurrentArticleMeta'
import { useRouteMatch } from 'react-router-dom'
import { HANDBOOK_PATH, DOC_PATH, FOLDER_PATH } from 'paths'
import { useHandbook } from 'components/Handbook2_0/hooks'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useIsCustomPath } from 'components/WorkspaceDashboard/hooks/useIsCustomPath'

export const useSidebarState = () => {
  const onCustomPath = useIsCustomPath()
  const currentWorkspaceId = useCurrentWorkspaceId()
  const handbookRouteMatch = useRouteMatch([HANDBOOK_PATH, FOLDER_PATH])
  const docRouteMatch = useRouteMatch(DOC_PATH)
  const handbook = useHandbook()
  const articleMeta = useCurrentArticleMeta()
  const previousVisible = useRef(false)

  const isVisible = (() => {
    // when in a handbook route, check if the handbook is loaded
    if (handbookRouteMatch) {
      return handbook != null || previousVisible.current
    }

    // when in a doc or custom route, checks for workspace or article meta (this allows for visitors on public docs)
    if (docRouteMatch || onCustomPath) {
      return currentWorkspaceId !== ALMANAC_CORE_WORKSPACE_ID || articleMeta != null || handbook != null
    }

    // returns true on other routes
    return true
  })() as boolean

  // previousVisible is used to know when we're visiting a handbook directly
  // when navigating in non-handbook pages, this will be true at some point, so when accessing a handbook we don't
  // hide the sidebar when loading the handbook (check the `!!handbook || previousVisible.current` line above)
  if (isVisible) previousVisible.current = true

  return { isVisible }
}
